import { Button, Flex, Typography } from '@iheartjane/reefer';
import type { ReactNode } from 'react';

import { LoadingWrapper } from '@jane/shared/components';

import { useKioskSpacing } from '../../../hooks';
import { Grid } from '../Grid/Grid';

export interface SpecialsGridProps {
  children: ReactNode;
  isLoading?: boolean;
  onViewLessClick?: () => void;
  onViewMoreClick?: () => void;
  showViewLess?: boolean;
  showViewMore?: boolean;
  title: ReactNode | string;
}

export const SpecialsGrid = ({
  children,
  isLoading = false,
  onViewLessClick,
  onViewMoreClick,
  showViewLess,
  showViewMore,
  title,
}: SpecialsGridProps) => {
  const { getKioskSpacing, isIpad } = useKioskSpacing();

  return (
    <Flex
      flexDirection="column"
      width="100vw"
      justifyItems="center"
      px={getKioskSpacing(64, 48)}
    >
      <LoadingWrapper isLoading={isLoading} variant="block" height="268px">
        {typeof title === 'string' ? (
          <Typography variant="header-bold">{title}</Typography>
        ) : (
          title
        )}

        <Grid
          gap={16}
          gridTemplateColumns={`repeat(auto-fill, minmax(${
            isIpad ? 320 : 344
          }px, 1fr))`}
          pt={24}
        >
          {children}
        </Grid>

        {(showViewLess || showViewMore) && (
          <Button
            onClick={showViewMore ? onViewMoreClick : onViewLessClick}
            full
            size={isIpad ? 'small' : 'default'}
            label={
              <Typography variant="body-bold">
                {showViewMore ? 'View more' : 'View less'}
              </Typography>
            }
            mt={24}
            variant="tertiary"
          />
        )}
      </LoadingWrapper>
    </Flex>
  );
};
